import { useRouter } from 'next/router';
import Button from '../components/Button/Button';

export default function Custom404() {
  const router = useRouter();
  return (
    <div className="relative">
      <section>
        <div className="flex flex-col items-center justify-center h-[840px] z-10 mdx:h-[700px]">
          <h1 className="font-medium text-xl">
            404 This page could not be found.
          </h1>
          <Button
            className="text-center  bg-brand-black50 mt-10"
            textClass="font-medium text-white text-sm"
            onClick={() => {
              router.push('/');
            }}>
            Go HomePage
          </Button>
        </div>
      </section>
    </div>
  );
}
